import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON,
  PAYOFF_COUPON_REFERENCE_RATE,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
  PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
} from '../../mockups/consts/product-capture-field-selectors.consts';

export const WARRANT_SETTINGS = {
  id: ProductTypeEnum.WARRANT,
  label: 'Warrant',
  effects: [
    {
      formControlNames: [
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON_REFERENCE_RATE,
        PAYOFF_COUPON,
        PAYOFF_CALLABILITY_CALLABILITY,
        PAYOFF_PARTICIPATION,
      ],
      hidden: true,
    },
    {
      formControlNames: [SUMMARY_UNDERLYING_ASSETS_GROUP],
      hidden: false,
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE],
      selectValues: ['SINGLE'],
      hidden: false,
      readOnly: true,
    },
    {
      formControlNames: [SUMMARY_SETTLEMENT_TYPE],
      selectValues: ['CASH'],
      readOnly: false,
    },
    {
      formControlNames: [
        PAYOFF_COUPON_TYPE,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
        PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
      ],
      hidden: true,
      selectValues: ['NONE'],
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_UPSIDE_TYPE],
      hidden: false,
      readOnly: false,
      selectValues: ['CALL_WARRANT'],
    },
  ],
};
